import type { ReactElement } from 'react';

import { Chip } from '@mui/material';
import { CircleCheck, CircleX } from 'lucide-react';

export type StatusPillVariant = 'error' | 'info' | 'ok' | 'warn';

interface StatusPillProps {
  label: string;
  variant: StatusPillVariant;
}

const COLOR_BY_VARIANT: Record<StatusPillVariant, 'error' | 'info' | 'success' | 'warning'> = {
  error: 'error',
  info: 'info',
  ok: 'success',
  warn: 'warning',
};

const ICON_BY_VARIANT: Partial<Record<StatusPillVariant, ReactElement>> = {
  error: <CircleX size={14} />,
  ok: <CircleCheck size={14} />,
};

export const StatusPill = ({ label, variant }: StatusPillProps) => (
  <Chip
    color={COLOR_BY_VARIANT[variant]}
    icon={ICON_BY_VARIANT[variant]}
    label={label}
    size="small"
    sx={{ fontSize: 10.5, fontWeight: 600 }}
  />
);
